import { render, staticRenderFns } from "./SvgMorphing.vue?vue&type=template&id=1cf99b4a&scoped=true&"
import script from "./SvgMorphing.vue?vue&type=script&lang=js&"
export * from "./SvgMorphing.vue?vue&type=script&lang=js&"
import style0 from "./SvgMorphing.vue?vue&type=style&index=0&id=1cf99b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf99b4a",
  null
  
)

export default component.exports